import { h, render } from 'vue'
import FeedbackModal from '~/components/base/FeedbackModal.vue'
import { useAuthLinks } from '~/composables/useAuthLinks'
import { useUserStore } from '~/store/common/user'
import { lockBodyScroll, unlockBodyScroll } from '~/utils/modal'

/**
 * @typedef {Object} FeedbackModalOptions
 * @property {Function} [onSubmitted] - 提交成功回调
 * @property {Function} [onClose] - 弹窗关闭回调
 */

/**
 * @description 打开意见反馈弹窗
 * @param {FeedbackModalOptions} options - 弹窗配置
 * @returns {void}
 */
export const openFeedbackModal = (options = {}) => {
  if (!import.meta.client) return

  const userStore = useUserStore()

  if (!userStore.isLoggedIn) {
    const { navigateToLogin } = useAuthLinks()
    navigateToLogin()
    return
  }

  const container = document.createElement('div')
  document.body.appendChild(container)
  lockBodyScroll()

  let hasClosed = false

  const cleanup = (result) => {
    if (hasClosed) return
    hasClosed = true

    if (result?.ok) {
      options.onSubmitted?.()
    }

    options.onClose?.(result)
    unlockBodyScroll()
    render(null, container)
    if (container.parentNode) {
      container.parentNode.removeChild(container)
    }
  }

  const vnode = h(FeedbackModal, {
    visible: true,
    'onUpdate:visible': (value) => {
      if (!value) {
        cleanup({ ok: false, cancel: false })
      }
    },
    onSubmitted: () => {
      cleanup({ ok: true, cancel: false })
    },
    onClose: () => {
      cleanup({ ok: false, cancel: false })
    },
  })

  const { vueApp } = useNuxtApp()
  vnode.appContext = vueApp._context

  render(vnode, container)
}
